// extracted by mini-css-extract-plugin
export default {"message__wrapper":"AppMessage_message__wrapper__+3QzS"};